import SingleMapping from "./SingleMapping";

const VariableMapping = ({ variableData, onChange, tableId, tableType, label = "Variable Mapping", formFields }) => {
  const handleMappingChange = (index, updatedItem) => {
    const updatedData = [...(variableData || [])];
    updatedData[index] = updatedItem;
    onChange(updatedData);
  };

  return (
    <div className="builder_form mt_2">
      <label className="builder_label">{label}</label>
      <table className="post_activity_sidebar_table">
        <thead>
          <tr>
            <th>Key</th>
            <th>Type</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {variableData?.map((data, index) => (
            <SingleMapping
              key={data.key || index}
              data={data}
              onChange={(updatedItem) => handleMappingChange(index, updatedItem)}
              tableId={tableId}
              tableType={tableType}
              formFields={formFields}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VariableMapping;
